import { IOption } from '@alixpartners/ui-components';
import cs from 'classnames';
import { ClaimButton } from 'components/ExhibitsExport/ClaimButton';
import { InputText } from 'components/UIComponents/InputText';
import Select from 'components/UIComponents/Select';
import { SvgIcon } from 'components/UIComponents/SvgIcon';
import { useState } from 'react';
import {
  emptyFooter,
  ExhibitFooter,
  FootnoteAppear,
  toFootnoteAppear,
  useExhibitExporterContext,
} from '../../providers';

const FOOTNOTE_APPEAR: IOption[] = [
  {
    label: 'First page only',
    value: FootnoteAppear.First,
  },
  {
    label: 'All pages',
    value: FootnoteAppear.All,
  },
];

export const ExhibitFootnoteSection = () => {
  const { value, updateValue } = useExhibitExporterContext();
  const footer = value.footer;

  const handleAddRow = () => {
    const newFooter = [...footer, emptyFooter];
    updateValue('footer', newFooter);
  };

  const handleUpdateRow = (id: number, newValue: ExhibitFooter) => {
    const newFooter = [...footer];
    newFooter[id] = newValue;
    updateValue('footer', newFooter);
  };

  const handleDeleteRow = (id: number) => {
    const newFooter = footer?.filter((_, idx) => idx !== id);
    updateValue('footer', newFooter);
  };

  return (
    <div className="exhibit-exporter__section">
      <div className="exhibit-exporter__section-title">Global Footnote</div>
      <div className="exhibit-exporter__section-content">
        {footer?.map((row, id) => (
          <FootnoteRow
            key={id}
            row={row}
            showDelete={footer!.length > 1}
            onChange={(r) => handleUpdateRow(id, r)}
            onDelete={() => handleDeleteRow(id)}
          />
        ))}
        <div className="exhibit-exporter__section-content-row-align-right">
          <ClaimButton iconName="add" onClick={handleAddRow}>
            Add another footnote
          </ClaimButton>
        </div>
      </div>
    </div>
  );
};
const FootnoteRow = (props: {
  row: ExhibitFooter;
  showDelete?: boolean;
  onChange?: (value: ExhibitFooter) => void;
  onDelete?: () => void;
}) => {
  const { row, showDelete, onChange, onDelete } = props;
  const [newText, setNewText] = useState<string>();

  //small optimization, to avoid unnecessary updates on every keystroke
  const text = newText ?? row.text;

  const handleTextChange = () => {
    if (!newText) return;
    onChange?.({ ...row, text: newText });
    setNewText(undefined);
  };

  const handleOptionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const optionId = toFootnoteAppear(e.target.value) ?? FootnoteAppear.First;
    onChange?.({ ...row, optionId });
  };

  return (
    <div className="exhibit-exporter__section-content-row">
      <div className="exhibit-exporter__section-content-row__footnote-text">
        <InputText
          autoFocus={false}
          label="Footnote text"
          placeholder="Input footnote text"
          value={text}
          maxLength={180}
          onChange={(e) => setNewText(e.target.value)}
          onBlur={handleTextChange}
        />
      </div>

      <Select
        label="Where should footnote appear?"
        options={FOOTNOTE_APPEAR}
        value={row.optionId}
        placeholder="Please select"
        onChange={handleOptionChange}
      />
      <button
        className={cs('exhibit-exporter__section-content-row__delete-btn', {
          show: showDelete,
        })}
        onClick={onDelete}
      >
        <SvgIcon iconName="delete" width={24} height={24} />
      </button>
    </div>
  );
};
